import { CloudflowEngine, type CloudFlowProvider } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentData } from "@doitintl/models-hooks";

export type ServicePointer = {
  provider: CloudFlowProvider;
  service: string;
};

export const useGetServiceDescriptor = (pointer: ServicePointer) => {
  const docRef = getCollection(CloudflowEngine)
    .doc("integrations")
    .collection("apis")
    .doc(pointer.provider)
    .collection("services")
    .doc(pointer.service);

  const [serviceData, loading, error] = useDocumentData(docRef, {
    caching: true,
    cachingKeys: ["cloudflow-service-descriptor", pointer.provider, pointer.service],
  });

  return { serviceData, loading, error };
};
